import React from "react";

const ProductCard = ({ product, hideImg }) => {
  const placeholderImage = "./image-placeholder.png"; // Path to your placeholder image

  return (
    <div className="data-card">
      <table className="data-table">
        <tbody>
          {!hideImg && product.designImageUrl && (
            <tr>
              <td colSpan="2">
                <img
                  src={product.designImageUrl || placeholderImage}
                  alt={product.name}
                  className="data-image"
                />
              </td>
            </tr>
          )}
          <tr>
            <td className="field-title">Name</td>
            <td className="field-value">{product.name}</td>
          </tr>
          {product.categoryName && (
            <tr>
              <td className="field-title">Collection</td>
              <td className="field-value">{product.categoryName}</td>
            </tr>
          )}
          <tr>
            <td className="field-title">Product ID</td>
            <td className="field-value">{product.externalId}</td>
          </tr>
          {product.subGroupName && (
            <tr>
              <td className="field-title">Subcategory</td>
              <td className="field-value">{product.subGroupName}</td>
            </tr>
          )}
          <tr>
            <td className="field-title">Unique Selling Points</td>
            <td className="field-value">{product.uniqueProperties}</td>
          </tr>
          <tr>
            <td className="field-title">Tags</td>
            <td className="field-value">{product.tags}</td>
          </tr>
          <tr>
            <td colSpan="2">
              <strong>Features</strong>
            </td>
          </tr>
          {product.featuresArray.map((feature, index) => (
            <tr key={index}>
              <td className="field-title">{feature.name}</td>
              <td className="field-value">{feature.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductCard;
